/**
 * The navy gradient panel with its concentric rings — the one motif that
 * recurs across Or's waiting screens.
 *
 * `busy` controls the SPINNER only. The rings are decoration and stay; a
 * spinner that keeps turning after the work finished is the untruthful
 * activity state §2 forbids, and the tests pin its absence.
 */

import React from 'react';

export default function MockPanel({ busy, title, sub, action, working }) {
  return (
    <div className="mk-panel">
      <div className="mk-rings" aria-hidden="true">
        <span className="mk-ring mk-ring--1" />
        <span className="mk-ring mk-ring--2" />
        <span className="mk-ring mk-ring--3" />
        <span className="mk-ring mk-ring--4" />
      </div>
      {busy ? (
        // The spinner is the panel's ONLY in-flow child, so the flex
        // centring puts it at the rings' centre. Stacking the caption with
        // it pushed the pair up as a block and left the spinner sitting
        // above the middle of the circles it is meant to sit inside; the
        // caption is therefore positioned, not stacked.
        //
        // `working` says which job is turning, and it is a live region
        // because when the left column has no questions left this panel is
        // the only thing on the screen that changes.
        <>
          <div className="mk-spinner" aria-hidden="true" />
          {working && <p className="mk-panel-working" role="status">{working}</p>}
        </>
      ) : (
        <div className="mk-panel-content">
          {title && <h2 className="mk-panel-title">{title}</h2>}
          {sub && <p className="mk-panel-sub">{sub}</p>}
          {action}
        </div>
      )}
    </div>
  );
}
